export default __webpack_public_path__ + "static/media/right.fe61177b.svg";